
import { mergeAttributes, Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'

import ResourceNodeComponent from './ResourceNodeComponent.vue'

export default Node.create({
  name: 'resourceComponent',
  group: 'inline',
  inline: true,
  content: 'text*',
  atom: true,

  addAttributes() {
    return {
      resourceUUID: {
        default: '',
      },
      label: {
        default: 'resource label',
        rendered: false,
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'resource-component',
        getAttrs: (element) => {
          return {
            resourceUUID: element.getAttribute('resourceUUID'),
            label: element.textContent || '',
          }
        }
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['resource-component', mergeAttributes(HTMLAttributes), 0]
  },

  addNodeView() {
    return VueNodeViewRenderer(ResourceNodeComponent)
  },
})
